import Main from '@/components/main/Main';
// 支付模块的路由

const systemRoutes = [
  {
    name: 'system',
    path: '/system',
    component: Main,
    redirect: '/system/role',
    meta: {
      showInMenu: true,
      showAlways: true, // 表示一定要展示子菜单
      title: '系统',
      icon: 'ios-apps'
    },
    children: [
      {
        name: 'system_user',
        path: 'user',
        component: () => import('@/emc-system/views/user'),
        meta: {
          showInMenu: true,
          path: '/system/user',
          title: '用户管理',
          icon: 'logo-apple'
        }
      },
      {
        name: 'system_userauth',
        path: 'userauth',
        component: () => import('@/emc-system/views/userauth'),
        meta: {
          showInMenu: true,
          path: '/system/userauth',
          title: '用户认证',
          icon: 'logo-apple'
        }
      },
      {
        name: 'system_userauth_edit',
        path: '/system/userauth/edit',
        component: () => import('@/emc-system/views/userauth/EditPage'),
        meta: {
          showInMenu: false
        }
      },
      {
        name: 'system_config',
        path: 'config',
        component: () => import('@/emc-system/views/config'),
        meta: {
          showInMenu: true,
          path: '/system/config',
          title: '系统配置',
          icon: 'logo-apple'
        }
      },
      {
        name: 'system_department',
        path: 'department',
        component: () => import('@/emc-system/views/department'),
        meta: {
          showInMenu: true,
          path: '/system/department',
          title: '部门管理',
          icon: 'logo-apple'
        }
      },
      {
        name: 'system_department_header',
        path: '/system/departmentHeader',
        component: () => import('@/emc-system/views/departmentheader'),
        meta: {
          showInMenu: false
        }
      },
      {
        name: 'system_param',
        path: 'param',
        component: () => import('@/emc-system/views/param'),
        meta: {
          showInMenu: true,
          path: '/system/param',
          title: '字典管理',
          icon: 'logo-apple'
        }
      },
      {
        name: 'system_permission',
        path: 'permission',
        component: () => import('@/emc-system/views/permission'),
        meta: {
          showInMenu: true,
          path: '/system/permission',
          title: '菜单管理',
          icon: 'logo-apple'
        }
      },
      {
        name: 'system_role',
        path: 'role',
        component: () => import('@/emc-system/views/role'),
        meta: {
          showInMenu: true,
          path: '/system/role',
          title: '角色管理',
          icon: 'logo-apple'
        }
      },
      {
        name: 'role_account',
        path: '/role/account',
        component: () => import('@/emc-system/views/role/roleAccount'),
        meta: {
          showInMenu: false,
        }
      },
      // {
      //   name: 'system_version',
      //   path: 'version',
      //   component: () => import('@/emc-system/views/version'),
      //   meta: {
      //     showInMenu: true,
      //     path: '/system/version',
      //     title: 'App版本管理',
      //     icon: 'logo-apple'
      //   }
      // },
      // {
      //   name: 'system_region',
      //   path: 'region',
      //   component: () => import('@/emc-system/views/region'),
      //   meta: {
      //     showInMenu: true,
      //     path: '/system/region',
      //     title: '区域管理',
      //     icon: 'logo-apple'
      //   }
      // },
      {
        name: 'system_log',
        path: 'log',
        component: () => import('@/emc-system/views/log'),
        meta: {
          showInMenu: true,
          path: '/system/log',
          title: '日志管理',
          icon: 'md-list'
        }
      },
      // {
      //   name: 'system_about',
      //   path: 'about',
      //   component: () => import('@/emc-system/views/sysabout'),
      //   meta: {
      //     showInMenu: true,
      //     path: '/system/about',
      //     title: '系统关于',
      //     icon: 'md-list'
      //   }
      // },
      // {
      //   name: 'system_about_add',
      //   path: '/system/about/add',
      //   component: () => import('@/emc-system/views/sysabout/EditPage'),
      //   meta: {
      //     showInMenu: false
      //   }
      // },
    ]
  }
];

export default systemRoutes;
